import { initialState } from '@ispm-client/modules/bpmn-modeler/store/state';
import { ExplorerViewActions, ExplorerViewActionTypes } from '@ispm-client/modules/bpmn-modeler/store/actions';

export function explorerViewCommand(state = initialState.explorerViewCommand, action: ExplorerViewActions) {
  switch (action.type) {
    case ExplorerViewActionTypes.COMMAND_CHANGE_SELECTED_NODE:
      return action.payload;
    default:
      return state;

  }
}
